$('.js-ya-reports-pdf').on('click', function() {
    const fileName = $(this).data('file-title');
    const pageUrl = `${location.protocol}//${location.host}${location.pathname}`;

    ym(23799535, 'reachGoal', 'reports_pdf',
        {
            reports_pdf: {
                eventCategory: 'reports',
                eventAction: 'download',
                eventLabel: 'pdf',
                eventContent: fileName,
                url: pageUrl
            }
        }
    );
});

$('.js-ya-forward-to-form').on('click', function() {
    const buttonText = $(this).text();
    const pageUrl = `${location.protocol}//${location.host}${location.pathname}`;

    ym(23799535, 'reachGoal', 'forward_to_form',
        {
            form: {
                eventCategory: 'form',
                eventAction: 'click_button',
                eventLabel: 'forward',
                name: buttonText,
                url: pageUrl
            }
        }
    );
});

$('.js-ya-open-accordion').on('click', function() {
    if ($(this).hasClass('active')) {
        const accordionText = $(this).text();

        ym(23799535, 'reachGoal', 'open_accordion',
            {
                accordion: {
                    eventCategory: 'accordion',
                    eventAction: 'click_element',
                    eventLabel: 'open',
                    eventContent: accordionText
                }
            }
        );
    }
});

$('.js-ya-download-catalog').on('click', function() {
    const buttonText = $(this).text();
    const pageUrl = `${location.protocol}//${location.host}${location.pathname}`;

    ym(23799535, 'reachGoal', 'download_catalog',
        {
            catalog: {
                eventCategory: 'catalog',
                eventAction: 'download',
                eventLabel: 'xlsx',
                name: buttonText,
                url: pageUrl
            }
        }
    );
});

$('.js-ya-download-tender').on('click', function() {
    const fileName = $(this).data('file-title');
    const pageUrl = `${location.protocol}//${location.host}${location.pathname}`;

    ym(23799535, 'reachGoal', 'tender',
        {
            download_tender: {
                eventCategory: 'tender',
                eventAction: 'download',
                eventLabel: 'pdf',
                name: fileName,
                url: pageUrl
            }
        }
    );
});

$('.js-ya-climat-change').on('click', function() {
    const buttonText = $(this).text();
    const pageUrl = `${location.protocol}//${location.host}${location.pathname}`;

    ym(23799535, 'reachGoal', 'climat_change',
        {
            climat_change :{
                eventCategory: 'button',
                eventAction: 'click',
                eventLabel: 'climat_change',
                name: buttonText,
                url: pageUrl
            }
        }
    );
});

$('.js-ya-contacts').on('click', function() {
    const buttonText = $(this).text();
    const pageUrl = `${location.protocol}//${location.host}${location.pathname}`;

    ym(23799535, 'reachGoal', 'contacts',
        {
            contacts_click: {
                eventCategory: 'contacts',
                eventAction: 'click',
                name: buttonText,
                url: pageUrl
            }
        }
    );
});

$('.js-ya-menu-button').on('click', function() {
    const pageUrl = `${location.protocol}//${location.host}${location.pathname}`;

    ym(23799535, 'reachGoal', 'menu_button',
        {
            menu_button: {
                eventCategory: 'menu',
                eventAction: 'click',
                eventLabel: 'open',
                url: pageUrl
            }
        }
    );
});

$('.js-ya-menu-footer').on('click', function() {
    const buttonText = $(this).text();
    const pageUrl = `${location.protocol}//${location.host}${location.pathname}`;

    ym(23799535, 'reachGoal', 'menu_footer',
        {
            menu: {
                eventCategory: 'menu',
                eventAction: 'click',
                eventLabel: 'footer',
                name: buttonText,
                url: pageUrl
            }
        }
    );
});

$('.js-ya-menu-header a').on('click', function() {
    const buttonText = $(this).text();
    const pageUrl = `${location.protocol}//${location.host}${location.pathname}`;

    ym(23799535, 'reachGoal', 'menu_header',
        {
            menu: {
                eventCategory: 'menu',
                eventAction: 'click',
                eventLabel: 'header',
                name: buttonText,
                url: pageUrl
            }
        }
    );
});

$('.js-ya-menu a').on('click', function() {
    const $button = $(this);
    const $buttonSvg = $button.find('svg');
    $buttonSvg.remove();
    const buttonText = $button.text();
    $button.append($buttonSvg);
    const pageUrl = `${location.protocol}//${location.host}${location.pathname}`;

    ym(23799535, 'reachGoal', 'menu',
        {
            menu: {
                eventCategory: 'menu',
                eventAction: 'click',
                eventLabel: 'items',
                name: buttonText,
                url: pageUrl
            }
        }
    );
});


// WEBPACK FOOTER //
// ./_src/js/Analytics.js